import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";
import * as authUtils from "utils/auth";

import styles from "./AuthDrawer.css";

class SignIn extends Component {
  constructor() {
    super();

    this.authString = authDrawerConstants.AUTH_URL;
    this.state = {};
  }

  componentDidMount() {
    authUtils.setNonce();
    this.setState({
      fbAuthUrl: authUtils.getFacebookUrl(),
      linkedInAuthUrl: authUtils.getLinkedInUrl(),
    });
  }

  changeStep(step, event) {
    if (event) {
      event.preventDefault();
    }

    this.props.authDrawerActions.changeStep(step);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.muted}>
          Sign in to Axios to save stories for later, get personalized news, and
          more!
        </div>
        <div className={styles.linkedInButton}>
          <a
            href={this.state.linkedInAuthUrl}
            className={classNames(
              styles.blueButton1,
              styles.block,
              styles.centered
            )}
          >
            <Icon name="linkedin-inverse" path="img" className={styles.icon} />
            Sign in with LinkedIn
          </a>
        </div>

        <div className={styles.facebookButton}>
          <a
            href={this.state.fbAuthUrl}
            className={classNames(
              styles.blueButton2,
              styles.block,
              styles.centered
            )}
          >
            <Icon name="facebook-inverse" path="img" className={styles.icon} />
            Sign in with Facebook
          </a>
        </div>

        <div className={styles.orWord}>OR</div>

        <div>
          {this.props.authDrawer.authDrawerOpen &&
          this.props.authDrawer.step === authDrawerConstants.SIGNIN ? (
            <iframe
              name="authframe"
              className={styles.authFrame}
              src={this.authString}
            />
          ) : null}
        </div>

        <div className={classNames(styles.marginTop10, styles.textCenter)}>
          <a
            onClick={this.changeStep.bind(
              this,
              authDrawerConstants.FORGOTPASSWORD1
            )}
            href="#"
            className={classNames(styles.bold, styles.blackLink)}
          >
            Forgot your password?
          </a>
        </div>

        <div className={classNames(styles.marginTop40, styles.textCenter)}>
          {/* eslint-disable-next-line react/no-unescaped-entities*/}
          Don't have an account?{" "}
          <a
            onClick={this.changeStep.bind(this, authDrawerConstants.REGISTER1)}
            href="#"
            className={classNames(styles.blackLink, styles.bold)}
          >
            Register now.
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn);
